import { select } from '@lingui/core/macro';
import type { PharmacyKind, ResellerWording } from 'types/models';
import { getShouldNotHappenError } from './baseUtils';

export const getPharmacyKindLabel = (pharmacyKind: PharmacyKind) =>
  select(pharmacyKind, {
    pharmacy: 'Pharmacie de ville',
    hospital_pharmacy: 'Pharmacie hospitalière',
    parapharmacy: 'Parapharmacie',
    medical_equipement_store: 'Magasin de matériel médical',
    sports_store: 'Magasin de sport',
    organic_store: 'Magasin bio',
    wholesaler: 'Grossiste',
    central_purchasing_office: 'Centrale d’achat',
    physiotherapist: 'Kinésithérapeute',
    retirement_home: 'Ehpad',
    e_commerce_website: 'Site e-commerce',
    specialized_store: 'Magasin spécialisé',
    gym: 'Salle de sport',
    beauty_sport_institute: 'Institut Beauté Sport',
    warehouse: 'Entrepôt',
    medical_profession_and_similar: 'Corps médical & assimilés',
    other: 'Autre',
  });

export const resellerWordingMapping = (pharmacyKind: PharmacyKind): ResellerWording => {
  switch (pharmacyKind) {
    case 'pharmacy':
    case 'hospital_pharmacy':
    case 'parapharmacy':
      return 'pharmacy';
    case 'medical_equipement_store':
    case 'sports_store':
    case 'organic_store':
    case 'wholesaler':
    case 'central_purchasing_office':
    case 'physiotherapist':
    case 'retirement_home':
    case 'e_commerce_website':
    case 'specialized_store':
    case 'gym':
    case 'beauty_sport_institute':
    case 'warehouse':
    case 'medical_profession_and_similar':
    case 'other':
      return 'point_of_sale';
    default:
      throw getShouldNotHappenError(pharmacyKind, 'pharmacy kind not supported');
  }
};
